import
{
	CharacterStateBase,
	Falling,
} from './_stateLibrary';
import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';

export class JumpRunning extends CharacterStateBase implements ICharacterState
{
	private alreadyJumped: boolean;
	private wasInAir: boolean;

	constructor(character: Character)
	{
		super(character);

		this.character.simulation.velocitySimulator.mass = 100;
		this.playAnimation(CharacterAnimation.JumpRunning, 0.03);
		this.alreadyJumped = false;
		this.wasInAir = false;
	}

	public update(timeStep: number): void
	{
		super.update(timeStep);
		this.onDie();
		this.character.setCameraRelativeOrientationTarget();

		// Move in air
		if (this.alreadyJumped)
		{
			this.character.simulation.setArcadeVelocityTarget(this.anyDirection() ? 0.8 : 0);
		}

		// Track when the character genuinely leaves the ground after jumping
		if (this.alreadyJumped && !this.character.physics.rayHasHit)
		{
			this.wasInAir = true;
		}

		// Physically jump
		if (this.timer > 0.13 && !this.alreadyJumped)
		{
			this.character.jump(4);
			this.alreadyJumped = true;

			this.character.simulation.rotationSimulator.damping = 0.3;
			this.character.physics.arcadeVelocityIsAdditive = true;
			this.character.physics.setArcadeVelocityInfluence(0.05, 0, 0.05);
		}
		else if (this.wasInAir && this.character.physics.rayHasHit)
		{
			this.setAppropriateDropState();
		}
		else if (this.animationEnded(timeStep))
		{
			this.character.setState(new Falling(this.character));
		}
	}
}
